/**
 * Pure locale data — no framework imports.
 * This module can be imported from standalone scripts (e.g. generateEnv.ts)
 * without pulling in @nuxtjs/i18n or vuetify.
 */

export const LOCALE = {
  EN: {
    code: 'en',
    name: 'English',
    file: 'en.ts',
  },
  DE: {
    code: 'de',
    name: 'Deutsch',
    file: 'de.ts',
  },
  // FR: {
  //   code: 'fr',
  //   name: 'Français',
  //   file: 'fr.ts',
  // },
  // IT: {
  //   code: 'it',
  //   name: 'Italiano',
  //   file: 'it.ts',
  // },
  // ES: {
  //   code: 'es',
  //   name: 'Español',
  //   file: 'es.ts',
  // },
} as const

export type LocaleCode = (typeof LOCALE)[keyof typeof LOCALE]['code']

export const AVAILABLE_LOCALE_CODES: readonly LocaleCode[] = Object.values(LOCALE).map((l) => l.code)
